import * as React from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import CoveoContentSearch from '@rotaryintl/app-coveo-content-search';
import Header from '@component/Header';

const CoveoSearch = (props) => {
  let sitecoreContextLang = props.sitecoreContext?.languageisocode;

  const Search = (
    <Header
      handleClick={() => {
        var value = document.getElementById('siteSearch').value;
      }}
    />
  );
  return (
    <>
      <CoveoContentSearch
        accessToken={props.fields?.APIKey?.value}
        language={sitecoreContextLang}
        organizationId={props.fields?.OrganizationId?.value}
        searchHub={props.fields?.SearchHub?.value}
        queryPipeline={props.fields?.QueryPipeline?.value}
        showLanguageFacet={props.fields?.ShowLanguageFacet?.value}
        query={Search}
      />
    </>
  );
};

export default withSitecoreContext()(CoveoSearch);
